// extracted by mini-css-extract-plugin
export var aircallIframe = "_gv-3";
export var fabContainer = "_gv-5";
export var fabRinging = "_gv-6";
export var loadingOverlay = "_gv-4";
export var pulse = "_gv-7";
export var widgetContent = "_gv-2";
export var widgetPanel = "_gv-0";
export var widgetPanelExpanded = "_gv-1";